import { useHits } from "react-instantsearch";
import { ProductSummary } from "@/common/productSummary/types";
import { SearchResult } from "@/components/Search/types";
import { ProductCardProps } from "@/components/ProductCard/types";
import { PRODUCT_INDEX_EN } from "@/constants/algolia";
import { convertHitToProductCardProps } from "../utils/convertHitToProductCardProps";
import { useSearchIndex } from "../components/SearchContextProvider";

export function useTypedSearchHits() {
  const { items: hits, results } = useHits<ProductSummary | SearchResult>();
  const { searchIndex } = useSearchIndex();
  const indexName = searchIndex || (PRODUCT_INDEX_EN as string);

  const cardProps: ProductCardProps[] = hits.map((hit) =>
    convertHitToProductCardProps(hit, indexName, results),
  );

  return {
    items: cardProps,
    results,
  };
}
